import { auth } from "@/auth";
import { Search } from "@/components/navbar/Search";
import { NoiseReductionLinks } from "@/components/navbar/NoiseReductionLinks";
import { AlertsLinks } from "@/components/navbar/AlertsLinks";
import { UserInfo } from "@/components/navbar/UserInfo";
import { Menu } from "@/components/navbar/Menu";
import { MinimizeMenuButton } from "@/components/navbar/MinimizeMenuButton";
import { DashboardLinks } from "@/components/navbar/DashboardLinks";
import { IncidentsLinks } from "@/components/navbar/IncidentLinks";
import { SetSentryUser } from "./SetSentryUser";
import "./Navbar.css";
export default async function NavbarInner() {
  const session = await auth();
  return <>
      <Menu session={session} data-sentry-element="Menu" data-sentry-source-file="Navbar.tsx">
        <Search session={session} data-sentry-element="Search" data-sentry-source-file="Navbar.tsx" />
        <div className="pt-4 space-y-4 flex-1 overflow-auto scrollable-menu-shadow">
          <IncidentsLinks session={session} data-sentry-element="IncidentsLinks" data-sentry-source-file="Navbar.tsx" />
          <AlertsLinks session={session} data-sentry-element="AlertsLinks" data-sentry-source-file="Navbar.tsx" />
          <NoiseReductionLinks session={session} data-sentry-element="NoiseReductionLinks" data-sentry-source-file="Navbar.tsx" />
          <DashboardLinks data-sentry-element="DashboardLinks" data-sentry-source-file="Navbar.tsx" />
        </div>
        <UserInfo session={session} data-sentry-element="UserInfo" data-sentry-source-file="Navbar.tsx" />
      </Menu>
      <MinimizeMenuButton data-sentry-element="MinimizeMenuButton" data-sentry-source-file="Navbar.tsx" />
      <SetSentryUser session={session} data-sentry-element="SetSentryUser" data-sentry-source-file="Navbar.tsx" />
    </>;
}